// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__XzsxO","divider":"tooltip_divider__VulE8","header":"tooltip_header__YQE2v","values":"tooltip_values__xA7bV"};